import {
  Stethoscope,
  Droplets,
  HeartPulse,
  Activity,
  Thermometer,
  Wind,
  Soup,
  FlaskConical,
  Gauge,
  Salad,
  ShieldPlus,
  UserRound,
  ClipboardList,
  BookOpenCheck,
  Users,
  CalendarClock,
  ShieldCheck,
  MessagesSquare,
  GraduationCap,
  BookOpen,
  FileHeart,
  Apple,
  ClipboardCheck,
} from "lucide-react";

export const trustCards = [
  {
    icon: Stethoscope,
    title: "General Physician Consultation",
    text: "Consultation for common and complex adult medical conditions.",
  },
  {
    icon: GraduationCap,
    title: "MD (Internal Medicine)",
    text: "Postgraduate specialist training in adult medicine",
  },
  {
    icon: Users,
    title: "Adult Healthcare",
    text: "Comprehensive, continuous medical care for adults",
  },
  {
    icon: Droplets,
    title: "Diabetes Care",
    text: "CCEBDM-certified, evidence-based diabetes management",
  },
];

export const expertise = [
  {
    icon: FileHeart,
    title: "General Physician Consultation",
    text: "Consultation for common and complex adult medical conditions.",
  },
  {
    icon: Stethoscope,
    title: "Internal Medicine",
    text: "Complete evaluation and management of adult medical conditions — from common illnesses to complex, multi-system problems.",
  },
  {
    icon: HeartPulse,
    title: "Hypertension Management",
    text: "Accurate blood pressure assessment and personalised treatment to protect your heart, brain and kidneys.",
  },
  {
    icon: Droplets,
    title: "Diabetes Management",
    text: "Evidence-based diabetes care: sugar control, complication screening, medicines review and practical lifestyle guidance.",
  },
  {
    icon: Activity,
    title: "Thyroid Disorders",
    text: "Diagnosis and long-term management of hypothyroidism, hyperthyroidism and related hormonal concerns.",
  },
  {
    icon: Thermometer,
    title: "Fever & Infections",
    text: "Systematic evaluation of fevers and infections — viral illness, dengue, malaria, typhoid and more.",
  },
  {
    icon: Wind,
    title: "Respiratory Diseases",
    text: "Care for asthma, COPD, chronic cough, breathlessness and respiratory infections.",
  },
  {
    icon: Soup,
    title: "Gastrointestinal Disorders",
    text: "Evaluation of acidity, gastritis, abdominal discomfort and day-to-day digestive health concerns.",
  },
  {
    icon: FlaskConical,
    title: "Liver & Metabolic Disorders",
    text: "Assessment and management of fatty liver and other liver-related medical conditions.",
  },
  {
    icon: Gauge,
    title: "Cholesterol & Cardiovascular Risk",
    text: "Lipid evaluation and practical, sustainable plans to reduce long-term heart disease risk.",
  },
  {
    icon: Salad,
    title: "Lifestyle & Metabolic Diseases",
    text: "Structured support for obesity, metabolic syndrome and lifestyle-related health issues.",
  },
  {
    icon: ShieldPlus,
    title: "Preventive Healthcare",
    text: "Health checkups, screening and early detection — keeping small problems from becoming big ones.",
  },
  {
    icon: UserRound,
    title: "General Adult Medicine",
    text: "Everyday medical care for adults: weakness, fatigue, body aches and symptoms that need a physician's eye.",
  },
];

export const conditions = [
  "Diabetes",
  "High Blood Pressure",
  "Thyroid Disorders",
  "Fever",
  "Viral Infections",
  "Respiratory Infections",
  "Asthma",
  "COPD",
  "Gastritis",
  "Acidity",
  "Fatty Liver",
  "Liver Disorders",
  "Cholesterol Disorders",
  "Anemia",
  "Vitamin Deficiencies",
  "Obesity & Metabolic Disorders",
  "Kidney-related Medical Conditions",
  "Joint & Musculoskeletal Complaints",
  "Weakness & Fatigue",
  "Chronic Medical Conditions",
];

export const whyConsult = [
  {
    icon: ClipboardList,
    title: "Comprehensive Medical Evaluation",
    text: "Your symptoms, history, reports and lifestyle are assessed together — not in isolation — for an accurate diagnosis.",
  },
  {
    icon: BookOpenCheck,
    title: "Evidence-Based Medical Care",
    text: "Treatment decisions follow established medical evidence and guidelines, explained to you in simple language.",
  },
  {
    icon: Users,
    title: "Patient-Centred Consultation",
    text: "Unhurried consultations where your questions are heard and your preferences shape the treatment plan.",
  },
  {
    icon: CalendarClock,
    title: "Chronic Disease Management",
    text: "Structured, long-term care for diabetes, blood pressure, thyroid and other ongoing conditions — with regular review.",
  },
  {
    icon: ShieldCheck,
    title: "Preventive Healthcare",
    text: "Risk assessment, screening and early intervention to prevent illness rather than only treat it.",
  },
  {
    icon: MessagesSquare,
    title: "Clear Communication",
    text: "You leave every consultation understanding your diagnosis, your medicines and the next steps.",
  },
];

export const resources = [
  {
    icon: Droplets,
    title: "Diabetes",
    text: "Understanding blood sugar, HbA1c, diet basics and why regular monitoring matters.",
  },
  {
    icon: HeartPulse,
    title: "Blood Pressure",
    text: "What your BP numbers mean, home monitoring tips and when readings need attention.",
  },
  {
    icon: Activity,
    title: "Thyroid",
    text: "Common thyroid symptoms, testing and what long-term management looks like.",
  },
  {
    icon: Thermometer,
    title: "Fever",
    text: "Sensible fever care at home and the warning signs that mean you should see a doctor.",
  },
  {
    icon: Gauge,
    title: "Cholesterol",
    text: "Understanding your lipid report and everyday habits that protect your heart.",
  },
  {
    icon: FlaskConical,
    title: "Fatty Liver",
    text: "What fatty liver means, its common causes and how lifestyle changes help.",
  },
  {
    icon: Apple,
    title: "Healthy Lifestyle",
    text: "Practical guidance on food, movement, sleep and stress for long-term health.",
  },
  {
    icon: ClipboardCheck,
    title: "Preventive Health Checkups",
    text: "Which screenings matter at your age and how often you should get tested.",
  },
];

export const faqs = [
  {
    q: "Who is Dr. Suyash Bhadoriya?",
    a: "Dr. Suyash Bhadoriya is an MBBS, MD (Internal Medicine), CCEBDM physician based in Bhopal, Madhya Pradesh. He is an Assistant Professor and practises as a General Physician & Internal Medicine Specialist at Shree Multispeciality Hospital, Saket Nagar, Bhopal, providing comprehensive medical care for adults.",
  },
  {
    q: "What is MD (Internal Medicine)?",
    a: "MD (Doctor of Medicine) in Internal Medicine is a postgraduate specialist qualification focused on diagnosing and treating diseases in adults. An internal medicine specialist — often called a physician — manages conditions affecting the heart, lungs, liver, kidneys, metabolism, infections and chronic illnesses such as diabetes and hypertension.",
  },
  {
    q: "What conditions does an Internal Medicine physician manage?",
    a: "A physician evaluates and manages diabetes, high blood pressure, thyroid disorders, fevers and infections, respiratory conditions like asthma and COPD, digestive and liver problems, cholesterol disorders, anemia, weakness and fatigue, and other common or complex adult medical conditions.",
  },
  {
    q: "When should I consult a physician?",
    a: "Consult a physician for persistent or unexplained symptoms such as fever lasting more than a few days, unusual fatigue, uncontrolled blood sugar or blood pressure, breathlessness, digestive problems, or for a general health evaluation and preventive checkup.",
  },
  {
    q: "Does Dr. Suyash Bhadoriya provide diabetes management?",
    a: "Yes. Dr. Bhadoriya holds a Certificate Course in Evidence-Based Diabetes Management (CCEBDM) and provides comprehensive diabetes care — including blood sugar control, medication review, complication screening and lifestyle guidance.",
  },
  {
    q: "When should I consult a doctor for high blood pressure?",
    a: "You should consult a doctor if your readings are repeatedly above 140/90 mmHg, if you experience headaches, dizziness or chest discomfort with high readings, or if you are already on medication but your pressure remains uncontrolled. Very high readings with severe symptoms need urgent medical attention.",
  },
  {
    q: "How can I book an appointment?",
    a: "You can request an appointment through the form on this website, call the clinic at 0755-3100126, or call/WhatsApp 9009147999. OPD consultations are held Monday to Friday, 4:00 PM to 7:30 PM, and Sunday 1:00 PM to 3:00 PM (Saturday closed). You will receive confirmation of available timings.",
  },
  {
    q: "Where is Dr. Suyash Bhadoriya's clinic located?",
    a: "The clinic is at Shree Multispeciality Hospital, 271/2A, Saket Nagar (near AIIMS Gate No. 3, Habib Ganj), Bhopal, Madhya Pradesh 462024. You can use the map on this website for directions.",
  },
];

export const navLinks = [
  { label: "Home", href: "/#home" },
  { label: "About", href: "/#about" },
  { label: "Expertise", href: "/#expertise" },
  { label: "Publications", href: "/#publications" },
  { label: "Conditions", href: "/#conditions" },
  { label: "Patient Resources", href: "/#resources" },
  { label: "Blog", href: "/#blog" },
  { label: "Contact", href: "/#contact" },
];

export const marqueeItems = [
  "Internal Medicine",
  "Diabetes Care (CCEBDM)",
  "Hypertension",
  "Adult Healthcare",
  "Preventive Care",
  "Fever & Infections",
  "Thyroid Disorders",
  "Lifestyle Diseases",
];

export { BookOpen, FileHeart };
